import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import BlockIcon from "@mui/icons-material/Block";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import MessageIcon from "@mui/icons-material/Message";
import PendingIcon from "@mui/icons-material/Pending";
import TodayIcon from "@mui/icons-material/Today";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { formatMoney, formatPercent } from "./utils";

const KpiCard = ({ label, value, subtitle, bgcolor, icon: Icon }) => (
  <Card sx={{ height: "100%", borderTop: 4, borderColor: bgcolor }}>
    <CardContent sx={{ minHeight: 120 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <Box>
          <Typography variant="caption" color="text.secondary">
            {label}
          </Typography>
          <Typography variant="h5" fontWeight={700} sx={{ mt: 0.5 }}>
            {value}
          </Typography>
          {subtitle ? (
            <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.5 }}>
              {subtitle}
            </Typography>
          ) : null}
        </Box>
        {Icon ? <Icon sx={{ color: bgcolor, fontSize: 32, opacity: 0.85 }} /> : null}
      </Box>
    </CardContent>
  </Card>
);

const SmsMonitoringKpiCards = ({ summary }) => {
  if (!summary) return null;

  const cards = [
    {
      label: "کل پیامک‌ها",
      value: formatMoney(summary.totalSms),
      bgcolor: "primary.main",
      icon: MessageIcon,
    },
    {
      label: "موفق",
      value: formatMoney(summary.successfulSms),
      subtitle: formatPercent(summary.successRatePercent),
      bgcolor: "success.main",
      icon: TrendingUpIcon,
    },
    {
      label: "ناموفق",
      value: formatMoney(summary.failedSms),
      subtitle: formatPercent(summary.failureRatePercent),
      bgcolor: "error.main",
      icon: TrendingDownIcon,
    },
    {
      label: "در انتظار ارسال",
      value: formatMoney(summary.pendingSms),
      bgcolor: "warning.main",
      icon: PendingIcon,
    },
    {
      label: "مجموع هزینه",
      value: `${formatMoney(summary.totalCost)} ریال`,
      bgcolor: "#1a237e",
      icon: AttachMoneyIcon,
    },
    {
      label: "میانگین هزینه هر پیامک",
      value: `${formatMoney(summary.averageCost)} ریال`,
      bgcolor: "#e65100",
      icon: AttachMoneyIcon,
    },
    {
      label: "پیامک‌های امروز",
      value: formatMoney(summary.todaySms),
      bgcolor: "info.main",
      icon: TodayIcon,
    },
    {
      label: "خطاهای امروز",
      value: formatMoney(summary.todayFailed),
      bgcolor: "error.dark",
      icon: ErrorOutlineIcon,
    },
  ];

  if (summary.qaBlockedSms > 0) {
    cards.push({
      label: "پیامک‌های مسدودشده تست",
      value: formatMoney(summary.qaBlockedSms),
      bgcolor: "warning.dark",
      icon: BlockIcon,
    });
  }

  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      {cards.map((card) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={card.label}>
          <KpiCard {...card} />
        </Grid>
      ))}
    </Grid>
  );
};

export default SmsMonitoringKpiCards;
